import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, Modal, PrimaryButton, setDateWithTimezone, toISOStringWithoutTimezone, toast, Hint, getFormattedUtcOffset } from '@systemeio/ui';
import { useScheduleNewsletter } from 'modules/newsletters/single/hooks/use-schedule-newsletter';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterViewApiInterface, NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { filterPassedTime, removeTimezoneFromString } from 'shared/utils/date-time-format';
import { KeyedMutator } from 'swr';
import TransLoco from 'shared/components/trans-loco';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
export interface ScheduleNewsletterModalProps {
  scheduledAt: NewsletterViewApiInterface['scheduledAt'] | undefined;
  newsletterId: NewsletterId;
  onSave: () => Promise<void>;
  onClose: () => void;
  opened: boolean;
  isTagsSelected: boolean;
  mutateNewslettersData: KeyedMutator<NewsletterViewApiType>;
  title: string;
}
export const ScheduleNewsletterModal = t0 => {
  const $ = _c(52);
  const {
    scheduledAt,
    newsletterId,
    onSave,
    onClose,
    opened,
    isTagsSelected,
    mutateNewslettersData,
    title
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [date, setDate] = useState(null);
  const [error, setError] = useState("");
  const [isScheduleNewsletterFetching, setIsScheduleNewsletterFetching] = useState(false);
  const {
    fetcherScheduleNewsletter
  } = useScheduleNewsletter();
  const t1 = setDateWithTimezone(undefined, user?.timezone);
  let t2;
  if ($[0] !== user?.timezone) {
    t2 = setDateWithTimezone(undefined, user?.timezone).getFullYear();
    $[0] = user?.timezone;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const maxDate = t1.setFullYear(t2 + 1);
  let t3;
  if ($[2] !== onClose) {
    t3 = () => {
      onClose();
      setDate(null);
      setError("");
    };
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handelClose = t3;
  let t4;
  if ($[4] !== date || $[5] !== opened || $[6] !== scheduledAt || $[7] !== user?.timezone) {
    t4 = () => {
      if (opened && !date) {
        if (scheduledAt) {
          const data = removeTimezoneFromString(scheduledAt);
          setDate(data);
        } else {
          const date_0 = setDateWithTimezone(undefined, user?.timezone);
          date_0.setMinutes(date_0.getMinutes() + 1);
          setDate(toISOStringWithoutTimezone(date_0));
        }
      }
    };
    $[4] = date;
    $[5] = opened;
    $[6] = scheduledAt;
    $[7] = user?.timezone;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = user?.timezone;
  let t6;
  if ($[9] !== date || $[10] !== opened || $[11] !== scheduledAt || $[12] !== t5) {
    t6 = [scheduledAt, date, opened, t5];
    $[9] = date;
    $[10] = opened;
    $[11] = scheduledAt;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t4, t6);
  let t7;
  if ($[14] !== date || $[15] !== fetcherScheduleNewsletter || $[16] !== handelClose || $[17] !== isTagsSelected || $[18] !== mutateNewslettersData || $[19] !== newsletterId || $[20] !== onSave || $[21] !== t) {
    t7 = async () => {
      if (!date) {
        return;
      }
      if (!isTagsSelected) {
        return toast.error(t("dashboard.newsletter_editor.select_tags_warning_message"));
      }
      setIsScheduleNewsletterFetching(true);
      ;
      try {
        await onSave();
        await fetcherScheduleNewsletter(newsletterId, {
          sendAt: date
        });
        await mutateNewslettersData(data_0 => data_0 && {
          ...data_0,
          scheduledAt: date
        });
        handelClose();
      } catch (t8) {
        const e = t8;
      }
      setIsScheduleNewsletterFetching(false);
    };
    $[14] = date;
    $[15] = fetcherScheduleNewsletter;
    $[16] = handelClose;
    $[17] = isTagsSelected;
    $[18] = mutateNewslettersData;
    $[19] = newsletterId;
    $[20] = onSave;
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleConfirm = t7;
  const t8 = user?.timezone;
  let t9;
  if ($[23] !== t8) {
    t9 = setDateWithTimezone("", t8);
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== user?.timezone) {
    t10 = time => filterPassedTime(time, user?.timezone);
    $[25] = user?.timezone;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = date_1 => {
      setDate(date_1);
    };
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      a: <LinkWithoutPrefetch href="/profile/account-settings" target="_blank" rel="noreferrer" className="primary-link" />
    };
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = <TransLoco t={t} i18nKey="dashboard.newsletter.schedule_modal_hint_tooltip" components={t12} />;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = `${user?.timezone}`;
  let t15;
  if ($[31] !== t14) {
    t15 = {
      timezone: t14
    };
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t || $[34] !== t15) {
    t16 = <TransLoco t={t} i18nKey="dashboard.newsletter.schedule_modal_hint" values={t15} />;
    $[33] = t;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = user?.dashboardLocale;
  const t18 = user?.timezone;
  let t19;
  if ($[36] !== t17 || $[37] !== t18) {
    t19 = getFormattedUtcOffset(t17, t18);
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const t20 = ` (${t19})`;
  let t21;
  if ($[39] !== t13 || $[40] !== t16 || $[41] !== t20) {
    t21 = <Hint label={t13}>{t16}{t20}</Hint>;
    $[39] = t13;
    $[40] = t16;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = !date;
  let t23;
  if ($[43] !== handleConfirm) {
    t23 = e_0 => {
      e_0.preventDefault();
      handleConfirm();
    };
    $[43] = handleConfirm;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t) {
    t24 = t("dashboard.newsletter_editor.save_and_schedule");
    $[45] = t;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== isScheduleNewsletterFetching || $[48] !== t22 || $[49] !== t23 || $[50] !== t24) {
    t25 = <div className="flex justify-center"><PrimaryButton isFetching={isScheduleNewsletterFetching} disabled={t22} width="large" onClick={t23} type="submit">{t24}</PrimaryButton></div>;
    $[47] = isScheduleNewsletterFetching;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  return <><Modal isFetching={isScheduleNewsletterFetching} isCentered={true} opened={opened} onClose={onClose} title={title}><form className="m-auto flex max-w-fit flex-col gap-6 lg:gap-10"><div className="flex flex-col gap-2"><DateTimePicker customProps={{
            minDate: t9,
            maxDate: new Date(maxDate),
            filterTime: t10
          }} key="date" value={date} onChange={t11} error={error} createdAt={user?.createdAt} timezone={user?.timezone} userDateFormat={user?.dateFormat} userTimeFormat={user?.timeFormat} intlLocale={intlLocale} />{t21}</div>{t25}</form></Modal></>;
};